export default __webpack_public_path__ + "static/media/ss.4c9d755f.png";